import View from 'root/view/base';

export default View.extend({
    initialize: function(options) {
        this.submit_button = options && options.submit_button ? options.submit_button : 'Save';
    },

    render: function() {
        var content =
        '<p>Having troubles in connecting with Monday.com? <a href="https://support.userback.io/en/articles/5209224" rel="noopener" target="_blank">Find out more</a>.</p>' +
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Monday.com Host</div>' +
                '<input type="text" class="solid medium" name="monday_host" maxlength="255" placeholder="e.g. my-team.monday.com" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">API Token (v2)</div>' +
                '<input type="password" class="solid medium" name="api_token" maxlength="255" required autocomplete="new-password">' +
                '<div class="margin-top-8"><a href="https://support.monday.com/hc/en-us/articles/360005144659-Does-monday-com-have-an-API-" rel="noopener" target="_blank">Where can I find my API token?</a></div>' +
            '</div>' +
            '<div class="sidebar-bottom">' +
                '<button class="primary" type="submit">' + this.submit_button + '</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        return this;
    }
});
